import { useEffect } from "react";

export function useIdlePreload(importFunctions) {
  useEffect(() => {
    if ("requestIdleCallback" in window) {
      const handles = importFunctions.map(fn =>
        requestIdleCallback(fn, { timeout: 2000 })
      );

      return () => handles.forEach(handle => cancelIdleCallback(handle));
    } else {
      // Fallback
      const timeout = setTimeout(() => {
        importFunctions.forEach(fn => fn());
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [importFunctions]);
}
